import React from "react";
import PermissionItem from "./PermissionItem";


const PermissionListWrapper = ({ treeData, level, onTreeNodeDataChange, ...props }) => {

    //** Handle Change's */
    const updateTreeData = (data, id) => {
        const newTreeData = treeData.map((item) =>
            item.id === id ? { ...item, ...data } : item
        );
        onTreeNodeDataChange && onTreeNodeDataChange(newTreeData);
    };

    return (
        <ul>
            {treeData?.map((item, index) => (
                <PermissionItem
                    key={index}
                    item={item}
                    level={level}
                    parentItem={null}
                    onParenetUpdate={updateTreeData}
                    {...props}
                />
            ))}
        </ul>
    );
};
export default PermissionListWrapper;